import styled, { css } from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledDisplayBrokerContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledBrokerNameBase = css`
    margin-bottom: 1rem;
    font-size: var(--size-18);
    font-weight: bold;
    color: var(--color-primary);
    @media ${breakpoints.xs} {
        margin-bottom: 0.1rem;
        font-size: var(--size-14);
    }
`;
